export default __webpack_public_path__ + "static/media/btc.5833f977.svg";